import type { Product } from 'reactApp/types/Billing';
import type { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

export interface BuyFamilyTariffProps {
    activeTabFromQuery?: string;
    onBuyClick: (product: Product) => void;
}

export interface BuyFamilyTariffContentProps {
    activeTab: ETabsName;
    setActiveTab: (activeTab: ETabsName) => void;
    onBuyClick: (product: Product) => void;
}

export enum FamilyTariffEventTypes {
    size = 'SIZE',
    close = 'CLOSE',
    success = 'SUCCESS',
}

export const MODAL_WIDTH = 1013;
